(() => {
  const formatter = new Intl.DateTimeFormat('en-US', {
    timeZone: 'America/New_York',
    weekday: 'short',
    hour: 'numeric',
    hourCycle: 'h23'
  });
  const update = () => {
    const parts = Object.fromEntries(formatter.formatToParts(new Date()).map(part => [part.type, part.value]));
    const monday = parts.weekday === 'Sun' || (parts.weekday === 'Sat' && Number(parts.hour) >= 14);
    const sameDay = parts.weekday !== 'Sun' && Number(parts.hour) < 14;
    const key = monday ? 'monday' : sameDay ? 'sameDay' : 'nextDay';
    document.querySelectorAll('[data-ars-delivery-message]').forEach(element => {
      element.textContent = element.dataset[key];
    });
  };
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', update, { once: true });
  } else {
    update();
  }
  document.addEventListener('shopify:section:load', update);
  document.addEventListener('visibilitychange', () => {
    if (!document.hidden) update();
  });
  setInterval(update, 60000);
})();
